export default "__VITE_PUBLIC_ASSET__12eae9ae__"